import Cookies from 'js-cookie'

const userName = 'imc-userName'
const token = 'imc-token'
const userRole = 'imc-r'
const userId = 'imc-u'
const userAccountId = 'imc-a'
// 用户名
export function getUserName() {
  return Cookies.get(userName)
}
export function setUserName(value) {
  return Cookies.set(userName, value)
}
export function removeUserName() {
  return Cookies.remove(userName)
}
// 密码
export function getToken() {
  return Cookies.get(token)
}
export function setToken(value) {
  return Cookies.set(token, value)
}
export function removeToken() {
  return Cookies.remove(token)
}
// 用户ID
export function getUserId() {
  return Cookies.get(userId)
}
export function setUserId(value) {
  return Cookies.set(userId, value)
}
export function removeUserId() {
  return Cookies.remove(userId)
}
// 用户角色
export function getUserRole() {
  return Cookies.get(userRole)
}
export function setUserRole(value) {
  return Cookies.set(userRole, value)
}
export function removeUserRole() {
  return Cookies.remove(userRole)
}
// 用户accountId
export function getUserAccountId() {
  return Cookies.get(userAccountId)
}
export function setUserAccountId(value) {
  return Cookies.set(userAccountId, value)
}
export function removeUserAccountId() {
  return Cookies.remove(userAccountId)
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js